/* START_MODULE_CONTRACT
 * PURPOSE: Константы типов периодичности накладных расходов (UC-013).
 * SCOPE: recurrence types, labels, day-of-week options.
 * DEPENDS: нет
 * LINKS: M-FE-PROJECTS
 * ROLE: TYPES
 * END_MODULE_CONTRACT
 *
 * START_MODULE_MAP
 * OVERHEAD_RECURRENCE_TYPES - DAILY | INTERVAL | WEEKLY
 * DAY_OF_WEEK_OPTIONS - ISO 1=пн … 7=вс
 * END_MODULE_MAP
 *
 * START_CHANGE_SUMMARY
 * LAST_CHANGE: 2026-07-03 - UC-013: заменяет DAY/WEEK/MONTH period units.
 * END_CHANGE_SUMMARY
 */

export const OVERHEAD_RECURRENCE_TYPES = {
  DAILY: 'DAILY',
  INTERVAL: 'INTERVAL',
  WEEKLY: 'WEEKLY',
};

export const OVERHEAD_RECURRENCE_TYPE_LABELS = {
  [OVERHEAD_RECURRENCE_TYPES.DAILY]: 'Каждый день',
  [OVERHEAD_RECURRENCE_TYPES.INTERVAL]: 'Каждые N дней',
  [OVERHEAD_RECURRENCE_TYPES.WEEKLY]: 'По дням недели',
};

export const DEFAULT_OVERHEAD_RECURRENCE_TYPE = OVERHEAD_RECURRENCE_TYPES.DAILY;

export const OVERHEAD_RECURRENCE_TYPE_OPTIONS = Object.values(OVERHEAD_RECURRENCE_TYPES).map(
  (value) => ({
    value,
    label: OVERHEAD_RECURRENCE_TYPE_LABELS[value],
  }),
);

/** ISO: 1 = понедельник … 7 = воскресенье. */
export const DAY_OF_WEEK_OPTIONS = [
  { value: 1, label: 'Пн' },
  { value: 2, label: 'Вт' },
  { value: 3, label: 'Ср' },
  { value: 4, label: 'Чт' },
  { value: 5, label: 'Пт' },
  { value: 6, label: 'Сб' },
  { value: 7, label: 'Вс' },
];

export const DAY_OF_WEEK_LABELS = Object.fromEntries(
  DAY_OF_WEEK_OPTIONS.map(({ value, label }) => [value, label]),
);

export const DEFAULT_INTERVAL_DAYS = 1;
